module.exports = __webpack_public_path__ + "static/media/logo_hongleongbank.cd16dd3d.svg";